import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";
import { useSite } from "@/context/SiteContentContext";
import { Reveal, SectionTag } from "./Reveal";
import { sectorIcons } from "@/i18n/content";
import { SECTOR_IMAGES } from "@/i18n/assets";

export default function Sectors() {
  const { t, lang, dir } = useLang();
  const { settings } = useSite();
  const items = t.sectors.items.map((s, i) => settings[`sector_${i}_${lang}`] || s);
  return (
    <section className="relative section-pad overflow-hidden" data-testid="sectors-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 mb-12 text-center">
        <Reveal><SectionTag>{t.sectors.tag}</SectionTag></Reveal>
        <Reveal delay={0.05}>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mt-5">{t.sectors.title}</h2>
        </Reveal>
      </div>

      <div className="space-y-4">
        <Marquee direction={dir === "rtl" ? "right" : "left"} speed={40} gradient gradientColor="#050914" gradientWidth={120} autoFill>
          {items.map((s, i) => {
            const Icon = sectorIcons[i % sectorIcons.length];
            return (
              <div key={i} className="mx-3 flex items-center gap-4 rounded-full border border-white/10 bg-surface ps-3 pe-7 py-2.5" data-testid={`sector-item-${i}`}>
                <span className="relative h-11 w-11 rounded-full overflow-hidden shrink-0 border border-white/10">
                  <img src={SECTOR_IMAGES[i]} alt={s} loading="lazy" className="h-full w-full object-cover" />
                  <span className="absolute inset-0" style={{ background: "rgba(5,9,20,0.35)" }} />
                </span>
                <Icon size={20} className="text-primary shrink-0" />
                <span className="text-xl sm:text-2xl font-bold whitespace-nowrap">{s}</span>
              </div>
            );
          })}
        </Marquee>
        <Marquee direction={dir === "rtl" ? "left" : "right"} speed={30} gradient gradientColor="#050914" gradientWidth={120} autoFill>
          {items.slice().reverse().map((s, i) => (
            <div key={i} className="mx-4 text-4xl sm:text-6xl font-extrabold outline-text whitespace-nowrap">
              {s}
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
